import React from 'react';
import KeywordTopicSearchField from './KeywordTopicSearchField';
import connectToStores from 'alt-utils/lib/connectToStores';
import FilterWordsStore from 'stores/triggers/FilterWordsStore';
import FilterWordsActions from 'actions/triggers/FilterWordsActions';
import SearchFieldsStore from 'stores/search/SearchFieldsStore';
import {ALL_OF_VALUE, KEYWORD_TOPIC} from 'utils/const';
import {getKeywordTopicLineItems} from 'stores/SearchStore';

class KeywordTopicSearchWidgets extends React.Component {
  constructor(props) {
    super(props);
    this.searchFieldToggled = this.searchFieldToggled.bind(this);
    this.renderComponent = this.renderComponent.bind(this);
  }

  static getStores() {
    return [FilterWordsStore, SearchFieldsStore];
  }

  static getPropsFromStores() {
    const sfState = SearchFieldsStore.getState();
    const allOrAny =
      sfState.get('searchFieldsState')?.get(KEYWORD_TOPIC)?.get('selectedOptionKey') ||
      ALL_OF_VALUE;
    return {
      topics: FilterWordsStore.getState().filterWords, // despite the name, these are all topics.
      contentLineItems: getKeywordTopicLineItems(sfState),
      allOrAny,
    };
  }

  componentDidMount() {
    // Avoid dispatch in the middle of a dispatch.
    FilterWordsActions.fetchAll.defer();
  }

  renderComponent(searchField) {
    return (
      <KeywordTopicSearchField
        topics={this.props.topics}
        searchField={searchField}
        key={searchField.name}
        toggled={this.searchFieldToggled(searchField)}
        updateLastToggledOnSearchWidget={this.props.updateLastToggledOnSearchWidget}
        canToggleKeywordTopicField={true}
        contentLineItems={this.props.contentLineItems}
        allOrAny={this.props.allOrAny}
      />
    );
  }

  searchFieldToggled(searchField) {
    if (this.props.searchFieldsToggled) {
      return this.props.searchFieldsToggled.get(searchField.name);
    }
    return false;
  }

  shouldNotRenderComponent(searchField) {
    return !(
      (this.props.shouldRenderToggled && this.searchFieldToggled(searchField)) ||
      (this.props.shouldRenderNotToggled && !this.searchFieldToggled(searchField))
    );
  }

  render() {
    const searchFields = this.props.searchFields.sort(sf => sf.order);
    return (
      <div className="search-widget">
        {searchFields
          .filterNot(this.shouldNotRenderComponent, this)
          .map(this.renderComponent, this)}
      </div>
    );
  }
}

export default connectToStores(KeywordTopicSearchWidgets);
